import { Centred, Contents } from '../../styles/mixins'

const styles = theme => ({
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  endpiece: {
    fontSize: theme.typography.subheading.fontSize,
    background: 'rgba(255,255,255,1)',
    padding: '2rem 7rem 0 7rem',
    maxWidth: 1024,
    // borderBottomLeftRadius: 25,
    // borderBottomRightRadius: 25
  },
  author: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.typography.body1.color,
  },
  date: {
    marginBottom: theme.spacing.unit * 3,
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/endpiece/styles.js